import React, { useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";

const Refer = ({ user }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = () => {
      const referralLink = `https://rjludo.com/login/${user.referral_code}`;
      const referralText = `🎮 rjludo पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हैं। 💰 दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 3% कमीशन दिया जाएगा। 
    👉 यहाँ खेलें: ${referralLink}`;
    alert(referralText, 'referralText');
        navigator.clipboard.writeText(referralText);

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Referral Message Copied",
          showConfirmButton: false,
          timer: 1200,
        });
      };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralLink = `https://rjludo.com/login/${user.referral_code}`;

const referralText = `rjludo पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हैं।
दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 3% कमीशन दिया जाएगा।
यहाँ खेलें: ${referralLink}`;

// WhatsApp share link
const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(referralText)}`;

  return (
    <>
      {/* <Header user={user} /> */}
      <div>
        <div
          className="leftContainer mb_space"
          style={{ minHeight: "100vh", height: "100%" }}
        >
          <section className="refer_page_premium modern_referral">
            {/* Earnings Overview */}
            <div className="refer_stats_card modern_card">
              <h2 className="profile_headings text-dark">Your Referral Analytics</h2>
              <div className="stats_grid modern_grid">
                <div className="stat_box">
                  <div className="stat_icon players_icon gradient_bg">
                    <i className="fa-solid fa-users"></i>
                  </div>
                  <div className="stat_data">
                    <h3>Referred Players</h3>
                    <h4>{user.referral_user?.length || 0}</h4>
                  </div>
                </div>

                <div className="stat_box earning_highlight">
                  <div className="stat_icon cash_icon gradient_bg">
                    <i className="fa-solid fa-wallet"></i>
                  </div>
                  <div className="stat_data">
                    <h3>Total Earnings</h3>
                    <h4><span>₹</span>{user.referral_earning}</h4>
                  </div>
                </div>
              </div>
            </div>

            {/* Referral Code & Share */}
            <div className="refer_share_card modern_card mt-4">
              <h2 className="profile_headings">Share Your Code</h2>
              <div className="refer_code_display flex_align">
                <div className="code_box gradient_border">
                  <span className="label">Your Unique Code</span>
                  <h3>{user.referral_code}</h3>
                </div>
                <button className="modern_copy_btn" onClick={copyCode}>
                  <FiCopy /> Copy
                </button>
              </div>

              <div className="divider_row">OR SHARE VIA</div>

              <div className="social_share_grid">
             
                <a  href={whatsappUrl} target="_blank" className="share_chip whatsapp">
                  <BsWhatsapp />
                </a>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`}
                  target="_blank" rel="noopener noreferrer" className="share_chip facebook" >
                  <AiFillFacebook />
                </a>
                 <a href={`https://telegram.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent(referralText)}`}  target="_blank" rel="noopener noreferrer"      className="share_chip telegram" >
                  <FaTelegramPlane />
                </a>
              </div>
            </div>

            {/* How It Works */}
            <div className="how_it_works_card modern_card mt-4">
              <h2 className="profile_headings">How It Works</h2>
              <div className="rules_list timeline_style">
                <div className="rule_item">
                  <span className="rule_num gradient_text">01</span>
                  <p>Refer and Earn <strong>3% Commission</strong> on every winning of your referred players.</p>
                </div>
                <div className="rule_item">
                  <span className="rule_num gradient_text">02</span>
                  <p>Example: If your player wins <strong>₹10,000</strong>, you get <strong>₹300</strong> instantly in your wallet.</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
